/**Get clients */
export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';

export const GET_CLIENTS_EXPIRATION = 'GET_CLIENTS_EXPIRATION';
export const GET_CLIENTS_EXPIRATION_SUCCESS = 'GET_CLIENTS_EXPIRATION_SUCCESS';

/** Authorization utilization timeline */

export const GET_BASIC_CLIENTS = 'GET_BASIC_CLIENTS';
export const GET_BASIC_CLIENTS_SUCCESS = 'GET_BASIC_CLIENTS_SUCCESS';

export const GET_BASIC_ACTIVE_CLIENTS = 'GET_BASIC_ACTIVE_CLIENTS';
export const GET_BASIC_ACTIVE_CLIENTS_SUCCESS = 'GET_BASIC_ACTIVE_CLIENTS_SUCCESS';
/**Create clients */
export const CREATE_CLIENT = 'CREATE_CLIENT';
export const RESEND_CLIENT_INVITE = 'RESEND_CLIENT_INVITE';
export const CREATE_CLIENT_INTAKE_FORM = 'CREATE_CLIENT_INTAKE_FORM';

/**Delete clients */
export const DELETE_CLIENT = 'DELETE_CLIENT';

/**Edit clients */
export const EDIT_CLIENT = 'EDIT_CLIENT';
export const EDIT_CLIENT_STATUS = 'EDIT_CLIENT_STATUS';

/**get client by id */
export const GET_CLIENT_BY_ID = 'GET_CLIENT_BY_ID';
export const GET_CLIENT_BY_ID_SUCCESS = 'GET_CLIENT_BY_ID_SUCCESS';

/**get client contacts */
export const GET_CLIENT_CONTACTS = 'GET_CLIENT_CONTACTS';
export const GET_CLIENT_CONTACTS_SUCCESS = 'GET_CLIENT_CONTACTS_SUCCESS';
export const GET_CLIENT_CONTACTS_INFO = 'GET_CLIENT_CONTACTS_INFO';
export const GET_CLIENT_CONTACTS_INFO_SUCCESS = 'GET_CLIENT_CONTACTS_INFO_SUCCESS';

/** Create client contact **/
export const CREATE_CLIENT_CONTACT = 'CREATE_CLIENT_CONTACT';
export const CREATE_CLIENT_CONTACT_SUCCESS = 'CREATE_CLIENT_CONTACT_SUCCESS';

/** Edit client contact **/
export const EDIT_CLIENT_CONTACT = 'EDIT_CLIENT_CONTACT';

/** Delete client contact **/
export const DELETE_CLIENT_CONTACT = 'DELETE_CLIENT_CONTACT';

/** Client Enrollment */
export const GET_CLIENT_ENROLLMENT = 'GET_CLIENT_ENROLLMENT';
export const GET_CLIENT_ENROLLMENT_SUCCESS = 'GET_CLIENT_ENROLLMENT_SUCCESS';

export const CREATE_CLIENT_ENROLLMENT = 'CREATE_CLIENT_ENROLLMENT';

export const EDIT_CLIENT_ENROLLMENT = 'EDIT_CLIENT_ENROLLMENT';

export const DELETE_CLIENT_ENROLLMENT = 'DELETE_CLIENT_ENROLLMENT';

export const TERMINATE_CLIENT_ENROLLMENT = 'TERMINATE_CLIENT_ENROLLMENT';

export const CHANGE_ENROLLMENT_TYPE = 'CHANGE_ENROLLMENT_TYPE';
export const GET_ENROLLMENT_PAYERS = 'GET_ENROLLMENT_PAYERS';
export const GET_ENROLLMENT_PAYERS_SUCCESS = 'GET_ENROLLMENT_PAYERS_SUCCESS';
/** End */

/**add Files to Client Auth */
export const GITE_CLIENT_AUTH_FILES = 'GITE_CLIENT_AUTH_FILES';
export const GITE_CLIENT_AUTH_FILES_SUCCESS = 'GITE_CLIENT_AUTH_FILES_SUCCESS';
export const ADD_FILES_TO_CLIENT_AUTH = 'ADD_FILES_TO_CLIENT_AUTH';
export const REMOVE_FILES_FROM_CLIENT_AUTH = 'REMOVE_FILES_FROM_CLIENT_AUTH';
export const EDIT_FILE_NAME_OF_CLIENT_AUTH = 'EDIT_FILE_NAME_OF_CLIENT_AUTH';

/** Client Address */
export const ADD_CLIENT_ADDRESS = 'ADD_CLIENT_ADDRESS';
export const EDIT_CLIENT_ADDRESS = 'EDIT_CLIENT_ADDRESS';
export const DELETE_CLIENT_ADDRESS = 'DELETE_CLIENT_ADDRESS';

/** Client Scheduling Address */
export const GET_CLIENT_SCHEDULING_ADDRESS = 'GET_CLIENT_SCHEDULING_ADDRESS';
export const GET_CLIENT_SCHEDULING_ADDRESS_SUCCESS = 'GET_CLIENT_SCHEDULING_ADDRESS_SUCCESS';
export const SET_CLIENT_SCHEDULING_ADDRESS = 'SET_CLIENT_SCHEDULING_ADDRESS';
export const CLEAR_CLIENT_SCHEDULING_ADDRESS = 'CLEAR_CLIENT_SCHEDULING_ADDRESS';

/** Staff Assignment */
export const ASSIGN_STAFF = 'ASSIGN_STAFF';
export const EDIT_ASSIGNED_STAFF = 'EDIT_ASSIGNED_STAFF';
export const GET_ASSIGNED_STAFFS = 'GET_ASSIGNED_STAFFS';
export const GET_ASSIGNED_STAFFS_SUCCESS = 'GET_ASSIGNED_STAFFS_SUCCESS';
export const REMOVE_STAFF = 'REMOVE_STAFF';

export const ADD_CLIENT_AUTHORIZATION = 'ADD_CLIENT_AUTHORIZATION';
export const EDIT_CLIENT_AUTHORIZATION = 'EDIT_CLIENT_AUTHORIZATION';
export const INACTIVATE_CLIENT_AUTHORIZATION = 'INACTIVATE_CLIENT_AUTHORIZATION';
export const CANCEL_CLIENT_AUTHORIZATION = 'CANCEL_CLIENT_AUTHORIZATION';
export const DELETE_CLIENT_AUTHORIZATION = 'DELETE_CLIENT_AUTHORIZATION';
export const DELETE_AUTHORIZED_SERVICE = 'DELETE_AUTHORIZED_SERVICE';
export const CLIENT_AUTHORIZATION_VISIBLE = 'CLIENT_AUTHORIZATION_VISIBLE';
export const GET_CLIENT_AUTHORIZATIONS = 'GET_CLIENT_AUTHORIZATIONS';
export const GET_CLIENT_AUTHORIZATIONS_SUCCESS = 'GET_CLIENT_AUTHORIZATIONS_SUCCESS';
export const GET_CLIENT_AUTHORIZATIONS_APPT = 'GET_CLIENT_AUTHORIZATIONS_APPT';
export const GET_CLIENT_AUTHORIZATIONS_APPT_SUCCESS = 'GET_CLIENT_AUTHORIZATIONS_APPT_SUCCESS';
export const REMOVE_CLIENT_AUTHORIZATIONS = 'REMOVE_CLIENT_AUTHORIZATIONS';
export const GET_AUTH_UTILIZATION = 'GET_AUTH_UTILIZATION';
export const GET_AUTH_UTILIZATION_SUCCESS = 'GET_AUTH_UTILIZATION_SUCCESS';

export const GET_AUTH_UNIT_INFO = 'GET_AUTH_UNIT_INFO';
export const GET_AUTH_UNIT_INFO_SUCCESS = 'GET_AUTH_UNIT_INFO_SUCCESS';

/** Forms */
export const GET_CLIENT_FORMS = 'GET_CLIENT_FORMS';
export const GET_CLIENT_FORMS_SUCCESS = 'GET_CLIENT_FORMS_SUCCESS';
export const ADD_CLIENT_FORM = 'ADD_CLIENT_FORM';
export const DELETE_CLIENT_FORM = 'DELETE_CLIENT_FORM';

/** Link Contact */
export const LINK_CONTACT_TO_CLIENT = "LINK_CONTACT_TO_CLIENT";

/** Portal Access */
export const GRANT_PORTAL_ACCESS = "GRANT_PORTAL_ACCESS";
export const REVOKE_PORTAL_ACCESS = "REVOKE_PORTAL_ACCESS";
export const SET_CLIENT_CONTACT_PASSWORD = "SET_CLIENT_CONTACT_PASSWORD";

/** Client Sections */
export const GET_CLIENT_SECTIONS = 'GET_CLIENT_SECTIONS';
export const GET_CLIENT_SECTIONS_SUCCESS = 'GET_CLIENT_SECTIONS_SUCCESS';
export const CREATE_CLIENT_SECTION = 'CREATE_CLIENT_SECTION';
export const EDIT_CLIENT_SECTION = 'EDIT_CLIENT_SECTION';
export const DELETE_CLIENT_SECTION = 'DELETE_CLIENT_SECTION';

/** Client Documentation */
export const GET_CLIENT_ALL_NOTES = 'GET_CLIENT_ALL_NOTES';
export const GET_CLIENT_ALL_NOTES_SUCCESS = 'GET_CLIENT_ALL_NOTES_SUCCESS';

export const DELETE_CLIENT_NOTES = 'DELETE_CLIENT_NOTES';
